<template>
  <div role="group" class="mb-3">
    <b-form-group :label="question">
      <b-row
        v-for="(answer, index) of this.answer"
        :key="`allergy-${index}`"
        class="mb-3"
      >
        <b-col cols="12">
          <b-form-input
            v-model="answer.allergy"
            :placeholder="body.arrraystructure[0].placeholder"
          ></b-form-input>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-form-textarea
            v-model="answer.effect"
            rows="4"
            :placeholder="body.arrraystructure[1].placeholder"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-button @click="addNewAllergy" variant="primary" pill
        >Add another allergy</b-button
      >
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "AccountDynamicArray",
  props: {
    body: {
      type: Object,
      default() {
        return {};
      },
    },
    question: {
      type: String,
      default: "",
    },
    preAnswer: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      answer: [{ allergy: "", effect: "" }],
    };
  },
  mounted() {
    let preAnswers = this.preAnswer.split(/\r?\n/);
    for (let itemIndex in preAnswers) {
      const itemData = preAnswers[itemIndex].split(":");
      this.answer.push({ allergy: itemData[0], effect: itemData[1] });
    }
    if (this.preAnswer) {
      this.answer.shift();
    }
    this.$emit("load-next", this.body.next);
  },
  methods: {
    addNewAllergy() {
      this.answer.push({ allergy: "", effect: "" });
    },
  },
};
</script>

<style></style>
